import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Title from 'antd/es/typography/Title';
import { SpinLoader } from '../components/common/SpinLoader';
import { useMediaQuery } from 'react-responsive';
import RESOURCE_CONFIGS from '../constants/resourceConfig';

interface baseLayoutProps {
  pageTitle?: any;
  content: any;
  isLoading?: boolean;
}

export const BaseLayout = ({ pageTitle, content, isLoading }: baseLayoutProps) => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${RESOURCE_CONFIGS.RESPONSIVE_BREAKPOINTS.SM})`,
  });
  const titleLevel = isMobile ? 3 : 2;

  return (
    <Layout
      className="min-h-screen-minus-100 w-full bg-white px-8 pt-8"
      style={{ borderRadius: 8 }}
    >
      <Content>
        {isLoading ? (
          <div className="flex h-full items-center justify-center">
            <SpinLoader />
          </div>
        ) : (
          <div>
            {pageTitle && (
              <Title
                style={{
                  fontWeight: 700,
                  fontSize: isMobile ? '28px' : '44px',
                  lineHeight: '140%',
                  letterSpacing: '0px',
                }}
                level={titleLevel}
                className="font-bold text-label-black"
              >
                {pageTitle}
              </Title>
            )}
            <div className="pb-5">{content}</div>
          </div>
        )}
      </Content>
    </Layout>
  );
};
